import React, { useState, useEffect } from 'react';
import { getQuoteCalculateHome } from '@/_serveice/usercenter';

/**
 * 报价计算器：调用接口获取完整 HTML 页面，通过 iframe srcDoc 渲染
 */
const QuotationCalculator = () => {
  const [html, setHtml] = useState('');

  useEffect(() => {
    getQuoteCalculateHome()
      .then((res) => setHtml(res || ''))
      .catch(() => setHtml(''));
  }, []);

  return (
    <div
      style={{
        background: '#fff',
        borderRadius: 4,
        padding: 0,
        overflow: 'hidden',
      }}
    >
      {html ? (
        <iframe
          title="报价计算"
          srcDoc={html}
          style={{
            width: '100%',
            height: 'calc(100vh - 140px)',
            border: 0,
            display: 'block',
          }}
        />
      ) : (
        <div
          style={{
            height: 'calc(100vh - 140px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          加载中...
        </div>
      )}
    </div>
  );
};

export default QuotationCalculator;
